// extracted by mini-css-extract-plugin
module.exports = {"tile":"PersonalizedImage_tile__LNAn4"};